<template>
    <div>
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3>
            <!-- Alert -->
            <Alert v-if="alertType !== ''" :atype="alertType" :message="alertMessage" :visibility="visibility" />

            <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

            <!-- form-->
            <v-container>

                <v-card class="semi-transparent-5-bg">

                    <v-card-title style="border-bottom: 5px solid #3944bb">

                        <img src="//assets.office4u.xyz/photos/BO-Demo/game-transfer.svg"  style="float: left; width: 15%; max-width: 50px; margin-right: 15px;"/>

                        <div class="transfer-form-title">

                            <span>{{ $t( 'transfer.title').toUpperCase() }}</span>

                        </div>

                    </v-card-title>

                    <v-card-text>

                        <v-form ref="form" v-model="valid" lazy-validation>

                            <!--Amount -->
                            <v-layout row class="margin-5-top-bottom">

                                <v-flex xs4>

                                    <v-subheader class="inputlabel">{{ $t( 'deposit.amount', { currency : this.$store.getters.currency }) }}</v-subheader>

                                </v-flex>

                                <v-flex xs8 class="margin-16-right">

                                    <v-text-field id="transferAmountField" class="transfer-form transferAmountField" v-model="data.amount" :rules="amountRules" single-line box required></v-text-field>

                                </v-flex>

                            </v-layout>

                            <div style="margin-bottom: 1em;"></div>

                            <!--Product From -->
                            <v-layout row class="margin-5-top-bottom">

                                <v-flex xs4>

                                    <v-subheader class="inputlabel">{{ $t( 'transfer.product_from' ) }}</v-subheader>

                                </v-flex>

                                <v-flex xs8 class="margin-16-right">

                                    <v-select :items="productsFrom" v-model="data.productFrom" item-value="id" :rules="productFromRules">

                                        <template slot="selection" slot-scope="data">

                                            <v-flex xs12>

                                                <img :src="data.item.logo" width="35px;" style="margin-right: 5px;"/>

                                                {{ data.item.name }}

                                            </v-flex>

                                        </template>

                                        <template slot="item" slot-scope="data">

                                             <v-flex xs12>

                                                <img :src="data.item.logo" width="35px;" style="margin-right: 5px;"/>

                                                {{ data.item.name }}

                                            </v-flex>

                                        </template>

                                    </v-select>

                                </v-flex>

                            </v-layout>

                            <div style="margin-bottom: 1em;"></div>

                            <!--Product To -->
                            <v-layout row class="margin-5-top-bottom">

                                <v-flex xs4>

                                    <v-subheader class="inputlabel">{{ $t( 'transfer.product_to' ) }}</v-subheader>

                                </v-flex>

                                <v-flex xs8 class="margin-16-right">

                                    <v-select :items="productsTo" v-model="data.productTo" item-value="id" :rules="productToRules">

                                        <template slot="selection" slot-scope="data">

                                            <v-flex xs12>

                                                <img :src="data.item.logo" width="35px;" style="margin-right: 5px;"/>

                                                {{ data.item.name }}

                                            </v-flex>

                                        </template>

                                        <template slot="item" slot-scope="data">

                                             <v-flex xs12>

                                                <img :src="data.item.logo" width="35px;" style="margin-right: 5px;"/>

                                                {{ data.item.name }}

                                            </v-flex>

                                        </template>

                                    </v-select>

                                </v-flex>

                            </v-layout>

                            <div style="margin-bottom: 1em;"></div>

                            <v-layout row justify-center>

                                <v-btn :disabled="!valid" color="success" @click.prevent="transfer" class="font-size" small >
                                    {{ $t( 'transfer.transfer_now' ) }}
                                </v-btn>

                                <v-btn color="error" @click.prevent="reset" class="font-size" small >
                                    {{ $t( 'shared.reset' ) }}
                                </v-btn>

                            </v-layout>

                        </v-form>

                    </v-card-text>

                </v-card>

            </v-container>

        </v-flex>

        <!--snackbar-->
        <div v-if="ready == true">

            <snackbar :color="color" :icon="icon" :text="message" :show="snackbar" />

        </div>

    </div>

</template>

<script>
import snackbar from '@/components/Reusable/Snackbar.vue';
import Alert from "@/components/Reusable/Alert.vue";
import Api from "@/api";

export default {
    name: 'Transfer',
    data() {
        return {
            valid: true,
            data: {
                productFrom: null,
                productTo: null,
                amount: 0,
                minTransferAmount: 100
            },
            products:[],
            productsFrom: [],
            productsTo: [],
            alertType: "",
            alertMessage: "",
            visibility: false,
            progressbar: false,
            snackbar: false,
            message: "",
            color: "",
            icon: "",
            ready: false
        }
    },
    components: {
        Alert,
        snackbar
    },
    mounted() {

         if(this.$route.params.product) {

            this.data.productFrom = this.$route.params.product.id;

        }
        this.getProducts();

        this.getMinTransfer();

        $('input[type=text]').focus(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

           focusFormFieldAnimation(targetParentId);

        });

        $('input[type=text]').focusout(function() {

            let targetParentId = null;

            targetParentId = $(this).attr('id');

            unfocusFormFieldAnimation(targetParentId);

        });

         function focusFormFieldAnimation(targetParentId) {

            let targetParentClass = null;

            targetParentClass = $('.' + targetParentId + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','0px 0px 2px #ccc');

            targetParentClass.css('box-shadow','0 0 2px #fff, 0 0 5px #fff, 0 0 10px #fff');

            targetParentClass.css('transition-delay','0.1s');
        }

        function unfocusFormFieldAnimation(targetParentId) {

            let targetParentClass = null;

            targetParentClass = $('.' + targetParentId + ' .v-input__control .v-input__slot');

            targetParentClass.css('text-shadow','');

            targetParentClass.css('box-shadow','');

            targetParentClass.css('transition-delay','');
        }
    },
    watch: {
        'message': function(message) {
            let currentInstance = this;

            setTimeout(function() {

                currentInstance.ready = false;

                currentInstance.snackbar = false;

                if (message == currentInstance.$t( 'deposit.submit_ticket_success' )) {

                    return currentInstance.$router.push({
                        name: 'home'
                    });

                }

            } , 1500);
        },
        'data.productFrom': function(productFrom) {
            this.productsTo = this.products.filter(function(product) {
                return product.id != productFrom;
            });
            if(productFrom == this.data.productTo) {
                this.data.productTo = null;
            }
        },
        'data.productTo': function(productTo) {
            this.productsFrom = this.products.filter(function(product) {
                return product.id != productTo;
            });
            if(productTo == this.data.productFrom) {
                this.data.productFrom = null;
            }
        }
    },
    computed: {
        amountRules() {
            return [
                    v => !!v || this.$t( 'deposit.require_amount_validation_rule' ),
                    v => (v && v >= parseFloat(this.data.minTransferAmount)) || this.$t( 'deposit.min_amount_validation_rule', { amount: this.data.minTransferAmount, currency : this.$store.getters.currency} ),
            ]
        },
        productFromRules() {
            return [
                    v => !!v || this.$t( 'transfer.product_transfer_from_validation_rule' ),
                    v => (v && v != this.data.productTo) || this.$t( 'transfer.product_transfer_same_validation_rule' )
            ]
        },
        productToRules() {
            return [
                    v => !!v || this.$t( 'transfer.product_transfer_to_validation_rule' ),
                    v => (v && v != this.data.productFrom) || this.$t( 'transfer.product_transfer_same_validation_rule' )
            ]
        }
    },
    methods: {
        getImgUrl(name) {

            var images = require.context('@/assets/', false, /\.png$/);

            return images('./' + name + ".png");

        },
        reset() {

            this.data.productFrom = null;

            this.data.productTo = null;

            this.data.amount = 0;

        },
        async getProducts() {

            this.progressbar = true;

            let res = await Api.getProductsMember({
                access_token: this.$store.getters.user_token
            });

            this.progressbar = false;

            if (res && 'success' in res && res.success === true) {

                this.products = res.data;

                let currentInstance = this;

                this.products = this.products.map(function(product){

                    if(product.id == 1) {

                        product.logo = currentInstance.getImgUrl('wallet');

                    }

                    if(product.id != 1 && product.logo == '') {

                        product.logo = currentInstance.getImgUrl('coming-soon');

                    }

                    return product;

                });

                this.productsFrom = this.products;

                this.productsTo = this.products.filter(function(product) {

                    return product.id != currentInstance.data.productFrom;

                });

            } else {

                this.visibility = true;

                this.alertMessage = res.message;

                this.alertType = "error";

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }

        },
        async transfer() {

            if (this.$refs.form.validate()) {

                this.visibility = false;

                this.alertMessage = "";

                this.alertType = "";

                let res = await Api.postTransfer({
                    access_token: this.$store.getters.user_token,
                    product_to: this.data.productTo,
                    product_from: this.data.productFrom,
                    amount: this.data.amount
                });

                if (res && 'success' in res && res.success === true) {

                    this.message = res.message;

                    if (this.message == "Submit Ticket Successfully") {

                        this.message = this.$t( 'deposit.submit_ticket_success' );

                    }

                    this.icon = "done_all";

                    this.color = "green";

                    this.snackbar = true;

                    this.ready = true;

                } else {

                    this.visibility = true;

                    this.alertMessage = res.message;

                    this.alertType = "error";

                    if(res.message == "token invalid") {

                        this.$store.dispatch('logout', res.data);

                        this.$router.push({name: 'login'})

                    } else if(res.message == "Ticket Detail Invalid") {

                        for (var oprop in res.data) {

                            this.alertMessage += '<br>' + res.data[oprop];

                        }

                    } else {

                        if(typeof res.data === 'string' ) {

                            this.alertMessage = res.data;

                        }

                    }

                }

            } else {

                this.message = this.$t( 'deposit.not_completed_form' );

                this.icon = "clear";

                this.color = "red";

                this.snackbar = true;

                this.ready = true;

            }
        },
        async getMinTransfer() {

            let res = await Api.getMinTransfer();

            if (res) {

                this.data.minTransferAmount = res;

            }

        },

    }

}
</script>

<style scoped>
    .font-size{
        font-size: 12px;
    }

    .inputlabel {
        color: #4d4a4a;
        font-weight: bold;
    }

    .transfer-form-title{
    font-size: calc(1.0em + 1.5vmin);
    color: #3944bb;
    }

    .v-input--selection-controls {
        padding-top: 4px;
        margin-top: 11px;
    }

    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
</style>
